import { apiSlice } from "../../apiSlice";

/**
 * Endpoints del submodulo Inspeccion Previa (Importaciones): tablero del
 * controlador, reasignacion manual, zonas/puntos/personas y catalogos.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-08-18
 */
export const inspeccionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTableroInspeccion: builder.query({
      query: (params) => ({ url: `/Modimpxx/Inspeccion/tablero`, method: "GET", params }),
      providesTags: ["Inspeccion"],
    }),
    reasignarInspeccion: builder.mutation({
      query: (body) => ({ url: `/Modimpxx/Inspeccion/reasignar`, method: "PUT", body }),
      invalidatesTags: ["Inspeccion"],
    }),
    getZonasInspeccion: builder.query({
      query: () => ({ url: `/Modimpxx/Inspeccion/zonas`, method: "GET" }),
      providesTags: ["InspeccionZonas"],
    }),
    guardarZonaInspeccion: builder.mutation({
      query: (body) => ({ url: `/Modimpxx/Inspeccion/zonas`, method: "POST", body }),
      invalidatesTags: ["InspeccionZonas", "Inspeccion"],
    }),
    inactivarZonaInspeccion: builder.mutation({
      query: (ZONAIDXX) => ({ url: `/Modimpxx/Inspeccion/zonas/${ZONAIDXX}`, method: "DELETE" }),
      invalidatesTags: ["InspeccionZonas"],
    }),
    guardarPersonaInspeccion: builder.mutation({
      query: (body) => ({ url: `/Modimpxx/Inspeccion/personas`, method: "POST", body }),
      invalidatesTags: ["InspeccionZonas"],
    }),
    retirarPersonaInspeccion: builder.mutation({
      query: (body) => ({ url: `/Modimpxx/Inspeccion/personas/retirar`, method: "PUT", body }),
      invalidatesTags: ["InspeccionZonas"],
    }),
    buscarClientesInspeccion: builder.query({
      query: (q) => ({ url: `/Modimpxx/Inspeccion/clientes`, method: "GET", params: { q } }),
    }),
    getCatalogosInspeccion: builder.query({
      query: (params) => ({ url: `/Modimpxx/Inspeccion/catalogos`, method: "GET", params }),
    }),
    getInformeInspeccion: builder.query({
      query: (DOCNROXX) => ({ url: `/Modimpxx/Inspeccion/informe/${DOCNROXX}`, method: "GET" }),
      providesTags: ["InspeccionNovedades"],
    }),
    getNovedadesInspeccion: builder.query({
      query: (DOCNROXX) => ({ url: `/Modimpxx/Inspeccion/novedades/${DOCNROXX}`, method: "GET" }),
      providesTags: ["InspeccionNovedades"],
    }),
    decidirNovedadInspeccion: builder.mutation({
      // FormData: DOCNROXX, MDNVIDXX, DECISNOX y soporte (archivo) cuando
      // la decision es TOTAL_CON_SOPORTE. Invalida keyResultImpo: la
      // decision cambia el bloqueo, los RC, el diagnostico y la ficha
      // de la pantalla del DO — todos cuelgan de ese tag.
      query: (formData) => ({ url: `/Modimpxx/Inspeccion/novedades/decidir`, method: "POST", body: formData }),
      invalidatesTags: ["InspeccionNovedades", "Inspeccion", "keyResultImpo", "Create"],
    }),
  }),
});

export const {
  useGetTableroInspeccionQuery,
  useReasignarInspeccionMutation,
  useGetZonasInspeccionQuery,
  useGuardarZonaInspeccionMutation,
  useInactivarZonaInspeccionMutation,
  useGuardarPersonaInspeccionMutation,
  useRetirarPersonaInspeccionMutation,
  useGetCatalogosInspeccionQuery,
  useLazyGetCatalogosInspeccionQuery,
  useLazyBuscarClientesInspeccionQuery,
  useGetNovedadesInspeccionQuery,
  useGetInformeInspeccionQuery,
  useDecidirNovedadInspeccionMutation,
} = inspeccionApiSlice;
